import { useContext } from "react";
import { UnpayActionContext } from "./UnpayActionContext";

function useInitialize() {
  const { setElement, setShowModal } = useContext(UnpayActionContext);
  return (formDefaultValues: any) => {
    setElement(formDefaultValues);
    setShowModal(true);
  };
}

export default useInitialize;
